import OccSTable from './OccSTable'

OccSTable.install = function(Vue) {
  Vue.component(OccSTable.name, OccSTable)
}

export default OccSTable


// WEBPACK FOOTER //
// ./src/components/OccSTable/index.js